export default __webpack_public_path__ + "static/media/trash-red.55219405.svg";